var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereum1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_31609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.72656 30 0 23.2734 0 15C0 6.72656 6.72656 0 15 0C23.2734 0 30 6.72656 30 15C30 23.2734 23.2734 30 15 30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 20.4375V25.7578L21.8672 16.5L15.2812 20.4375ZM21.6328 14.7891L15.2812 4.24219V11.9062L21.6328 14.7891ZM15.2812 12.4922V19.0547L21.5859 15.375L15.2812 12.4922ZM8.39062 14.7891L14.7187 4.24219V11.9062L8.39062 14.7891ZM14.7187 12.4922V19.0547L8.41406 15.375L14.7187 12.4922ZM14.7187 20.4375V25.7578L8.13281 16.5L14.7187 20.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_31609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum1);
export default __webpack_public_path__ + "static/media/ethereum 1.085f0d35931026f9408a2ce99837d50d.svg";
export { ForwardRef as ReactComponent };